//@ts-check
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';

import { queryClient } from './queryClient.js';

import { AuthProvider } from '@/features/auth/AuthContext.jsx';
import { UploadQueueProvider } from '@/hooks/useUploadQueue.jsx';

/**
 * App-wide providers.
 * @param {{ children: import('react').ReactNode }} props
 * @returns {import('react').ReactElement}
 */
export function AppProviders({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <UploadQueueProvider>
          {children}
          <Toaster richColors position="top-right" />
        </UploadQueueProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
